var VisualWithVideo = {

	Init: function () {
		this.Configure();
	},

	Configure: function () {

		// Only load the iframes with video url's when we are not on an android or ios device.		
		var videoIframes = $('.video-iframe');

		var vimeoVideoIframes = $.grep(videoIframes, function(iframe) {
			return $(iframe).data('value') == 'vimeo';
		});

		var youTubeVideoIframes = $.grep(videoIframes, function (iframe) {
			return $(iframe).data('value') == 'youtube';
		});
		
		if (vimeoVideoIframes.length > 0) {
			
			$.getScript('//f.vimeocdn.com/js/froogaloop2.min.js', function() {
				for (var i = 0; i < vimeoVideoIframes.length; i++) {
					var vimeoFrame = $f(vimeoVideoIframes[i]);
					console.log(vimeoFrame);
					vimeoFrame.addEvent('ready', function (playerId) {
						var player = $f(playerId);
						player.addEvent('playProgress', function () {

							var playerIframe = $("#" + playerId);
							if (playerIframe.css('opacity') == 0) {								
								playerIframe.fadeTo(300, 1);
							}
						});
						player.api('setVolume', 0);						
					});

					$(vimeoVideoIframes[i]).prop('src', $(vimeoVideoIframes[i]).data('src'));
				}
			});		
		}

		if (youTubeVideoIframes.length > 0) {
			
			window.onYouTubeIframeAPIReady = function () {
				for (var i = 0; i < youTubeVideoIframes.length; i++) {
					$(youTubeVideoIframes[i]).prop('src', $(youTubeVideoIframes[i]).data('src'));

					var youTubeVideoId = $(youTubeVideoIframes[i]).prop('id');
					new YT.Player(youTubeVideoId, {
						events: {
							'onReady': function (e) {
								e.target.playVideo();
								e.target.mute();
							},
							'onStateChange': function (e) {
								if (e.data == YT.PlayerState.PLAYING) {
									var playerIframe = $("#" + youTubeVideoId);
									if (playerIframe.css('opacity') == 0) {										
										playerIframe.fadeTo(300, 1);
									}
								}
							}
						}
					});
				}				
			};

			$.getScript('//www.youtube.com/iframe_api');
		}
	}
};